import { IAdvertiserGridRow } from '@/Interfaces/Advertiser.interface';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectAdvertisersCategories } from '@/store/selectors/advertisers.selectors';
import { setSelectedAdvertiser } from '@/store/slices/advertisers.slice';
import { Link } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { useCallback, useMemo } from 'react';

const AdvertiserNameCell = ({ value, row }: GridRenderCellParams<IAdvertiserGridRow>) => {
  const dispatch = useAppDispatch();

  const categories = useAppSelector(selectAdvertisersCategories);

  const category = useMemo(() => {
    return categories.find(({ value }) => value === row.category);
  }, [categories, row]);

  const selectRow = useCallback(() => {
    if (!row) return;
    dispatch(setSelectedAdvertiser(row));
  }, [dispatch, row]);

  return (
    <div className='overflow-hidden'>
      <Link
        component='button'
        underline='hover'
        sx={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
        onClick={selectRow}
      >
        {value}
      </Link>
      {category && (
        <div className='text-[#84818A] text-[12px] font-medium text-ellipsis overflow-hidden'>{category.label}</div>
      )}
    </div>
  );
};

export default AdvertiserNameCell;
